<template>
  <span
    v-tooltip="history.length > 0 ? historyTooltip : null"
    :style="{ color: `#${statusOption.color}` }"
  >
    {{ statusOption.title }}<span v-if="vtiStatus"> / VTI {{ vtiStatus === 'pending' ? 'zurückgenommen' : 'abgeholt' }}</span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHistoryVTI } from '@/api/cars'

export default {
  name: 'MiaCarEditStatus',

  props: {
    status: {
      type: [String, Number],
      required: true
    },

    vtiStatus: {
      type: String,
      default: null,
      validate: () => true
    }
  },

  data: () => ({
    history: []
  }),

  computed: {
    ...mapGetters(['statusOptions']),

    statusOption() {
      return this.statusOptions.find(s => parseInt(s.id, 10) === parseInt(this.status, 10)) || {}
    },

    historyTooltip() {
      let tooltip = '<table>'
      this.history.forEach((item) => { tooltip += `<tr><td class="p-1">${item.item_created}</td><td class="p-1">${item.item_action}</td><td class="p-1">${item.item_firstname} ${item.item_lastname}</td></tr>` })
      tooltip += '</table>'
      return tooltip
    }
  },

  async created() {
    await this.$store.dispatch('loadStatusOptions')
    const [errors, response] = await getHistoryVTI(this.$route.params.carId)

    if (errors) {
      window.eventBus.$emit('mia-error', {
        error: ['Statushistorie konnte nicht abgerufen werden']
      })
      return
    }

    this.history = response
  }
}
</script>
